import { ReactNode } from 'react';
import { TGridHeader, GridCell } from '.';
export function GridRow<D extends { id: number }>({
  pointer,
  hover = true,
  index,
  id,
  children,
  onClick,
}: {
  pointer?: boolean;
  index?: number;
  id?: number;
  hover?: boolean;
  children?: ReactNode;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}) {
  return (
    <div
      onClick={onClick}
      className={`contents grid-row  ${pointer ? 'cursor-pointer' : ''} ${
        hover ? 'grid-row-hover' : ''
      }`}
      data-index={index}
      data-id={id}
    >
      {children}
    </div>
  );
}
export function RowWrapper<Data extends { id: number }>({
  pointer,
  hover = true,
  index,
  id,
  onClick,
  wrap = true,
  rowIndex,
  gridHeaders,
  renderCells,
  children,
  data,
}: {
  pointer?: boolean;
  wrap?: boolean;
  index?: number;
  id?: number;
  hover?: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  data: Data;
  rowIndex: number;
  gridHeaders?: TGridHeader[];
  renderCells?: (d: Data) => ReactNode[];
  children?: (d: Data, rowIndex: number) => ReactNode;
}) {
  if (!wrap)
    return (
      <RowRender
        children={children}
        data={data}
        columns={gridHeaders}
        rowIndex={rowIndex}
        renderCells={renderCells}
      />
    );
  return (
    <div
      onClick={onClick}
      className={`contents grid-row  ${pointer ? 'cursor-pointer' : ''} ${
        hover ? 'grid-row-hover' : ''
      }`}
      data-index={index}
      data-id={id}
    >
      <RowRender
        children={children}
        data={data}
        columns={gridHeaders}
        rowIndex={rowIndex}
        renderCells={renderCells}
      />
    </div>
  );
}
export function RowRender<Data>({
  children,
  renderCells,
  rowIndex,
  data,
  columns,
}: {
  columns?: TGridHeader[];
  data: Data;
  rowIndex: number;
  renderCells?: (d: Data) => ReactNode[];
  children?: (d: Data, rowIndex: number) => ReactNode;
}) {
  return (
    <>
      {children && !renderCells && children(data, rowIndex)}
      {renderCells &&
        !children &&
        renderCells(data).map((renderCell, index) => (
          <GridCell
            key={`${rowIndex}-${index}`}
            id={`${rowIndex}-${index}`}
            justifyContent={
              index === 0
                ? 'start'
                : columns && columns[index] && columns[index]['justifyContent']
                ? columns[index]['justifyContent']
                : undefined
            }
          >
            {renderCell}
          </GridCell>
        ))}
    </>
  );
}
